import { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import ArticleContent from './sugargoo-spreadsheet-guide/components/ArticleContent';
import { articles } from '@/mocks/seo-content';

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();

  const article = articles.find((a) => a.slug === slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!article) {
    return (
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <div className="pt-16 flex flex-col items-center justify-center min-h-[60vh] px-4">
          <div className="w-16 h-16 flex items-center justify-center rounded-full bg-primary-100 mb-4">
            <i className="ri-error-warning-line text-2xl text-primary-500"></i>
          </div>
          <h1 className="font-heading text-2xl font-bold text-foreground-950 mb-2">Article Not Found</h1>
          <p className="text-foreground-600 text-sm mb-6">The article you are looking for does not exist or has been moved.</p>
          <Link
            to="/"
            className="inline-flex items-center px-5 py-2.5 text-sm font-semibold rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-home-line mr-2"></i>
            Back to Homepage
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <div className="pt-16">
        <ArticleContent article={article} />
      </div>
      <Footer />
    </div>
  );
}